<script>
	
	import { SquareArrowOutUpRight } from 'lucide-svelte';

	export let iconClass = '';
</script>

<SquareArrowOutUpRight class={iconClass} />